export const LOGOUT = 'LOGOUT';
export const SET_CONTENT_THREADS = 'SET_CONTENT_THREADS';
export const SET_DISPLAY_CONTENT_THREADS = 'SET_DISPLAY_CONTENT_THREADS';
